import { nanoid } from 'nanoid'

export type Toast = { message: string; error?: boolean; duration?: number }

export type ToastState = Toast & { id: string }

export const useToast = () => {
  const toasts = useState<ToastState[]>('toasts', () => [])
  const show = (toastInfo: Toast | string): string => {
    if (typeof toastInfo === 'string') {
      toastInfo = { message: toastInfo }
    }

    // 日時ミリ秒 + 乱数
    const id = nanoid()

    // 表示
    toasts.value.unshift({ ...toastInfo, id })

    return id
  }
  const hide = (toastId: string) => {
    // 表示中のトーストのインデックスを取得
    const index = toasts.value.findIndex((t) => t?.id === toastId)

    // 既に非表示の場合は何もしない
    if (index === -1) return

    // 非表示
    toasts.value.splice(index, 1)
  }
  return {
    toasts,
    show,
    hide,
    success: (message: string, duration?: number) =>
      show({ message, duration }),
    error: (message: string, duration = 5000) =>
      show({ message, duration, error: true }),
  }
}
